<nav class="navbar navbar-expand-lg bg-white shadow-sm py-3 w-100 px-4 fixed-top"
  [ngClass]="{ 'gray-border': !isHomePage }" style="z-index: 1030;">
  @if(isHomePage) {
  <div class="container-fluid align-items-center justify-content-between">
    <a class="navbar-brand d-flex align-items-center" href="#">
      <img src="assets/images/vida-optima-logo.svg" alt="Vida Óptima" height="60" class="me-2 d-none d-lg-block" />
      <img src="assets/images/vida-optima-logo.svg" alt="Vida Óptima" class="me-2 d-lg-none" style="height: 50px;" />
    </a>

    <!-- Desktop elements -->
    <div class="d-none d-lg-flex align-items-center gap-3 ms-auto">
      <a href="#" class="text-secondary text-decoration-none small d-flex align-items-center mt-2">
        <span class="text-black">Vida óptima corporativo</span>
        <i class="bi bi-box-arrow-up-right ms-1 text-entremar-2 ps-2"></i>
      </a>
      <div class="search-box d-flex align-items-center rounded-pill border ps-3 pe-2 py-1">
        <i class="bi bi-search text-muted me-2"></i>
        <input type="text" class="form-control border-0 shadow-none" placeholder="¿Qué estás buscando?" />
      </div>
      <button class="btn btn-primary rounded-pill px-4" [routerLink]="['acceder']">
        Acceder
      </button>
    </div>

    <!-- Mobile elements -->
    <div class="d-flex d-lg-none align-items-center gap-3 ms-auto">
      <button class="btn btn-link text-dark p-0 me-2" type="button">
        <img src="assets/icons/home-search.svg" style="height: 30px;" />
      </button>
      <button class="btn btn-link text-dark p-0 me-2" type="button" [routerLink]="['acceder']">
        <img src="assets/icons/home-user.svg" style="height: 30px;" />
      </button>
      <button class="navbar-toggler border-0 p-0" type="button" data-bs-toggle="collapse" data-bs-target="#mobileMenu"
        aria-expanded="false" aria-controls="mobileMenu">
        <img src="assets/icons/home-menu.svg" style="height: 30px;" />
      </button>
    </div>
  </div>

  <!-- Mobile Menu Collapse -->
  <div class="collapse navbar-collapse bg-white d-lg-none" id="mobileMenu">
    <div class="mobile-menu-header d-flex justify-content-end py-3 px-3 w-100">
      <button class="btn btn-link text-dark p-0" type="button" data-bs-toggle="collapse" data-bs-target="#mobileMenu">
        <i class="bi bi-x-lg fs-4 text-primary-300"></i>
      </button>
    </div>
    <ul class="navbar-nav w-100 px-0">
      <li class="nav-item">
        <a class="nav-link fs-5 text-neutrals-800" href="#inicio" data-bs-toggle="collapse"
          data-bs-target="#mobileMenu">Inicio</a>
      </li>
      <li class="nav-item">
        <a class="nav-link fs-5 text-neutrals-800" href="#beneficios" data-bs-toggle="collapse"
          data-bs-target="#mobileMenu">Beneficios</a>
      </li>
      <li class="nav-item">
        <a class="nav-link fs-5 text-neutrals-800" href="#simulador" data-bs-toggle="collapse"
          data-bs-target="#mobileMenu">Simulador</a>
      </li>
      <li class="nav-item">
        <a class="nav-link fs-5 text-neutrals-800" href="#como-hacerlo" data-bs-toggle="collapse"
          data-bs-target="#mobileMenu">Cómo
          hacerlo</a>
      </li>
      <li class="nav-item">
        <a class="nav-link fs-5 text-neutrals-800" href="#preguntas-frecuentes" data-bs-toggle="collapse"
          data-bs-target="#mobileMenu">Preguntas frecuentes</a>
      </li>
      <li class="nav-item">
        <a href="#" class="nav-link d-flex align-items-center justify-content-between fs-5 text-neutrals-800">
          <span>Vida optima corporativo</span>
          <img src="assets/icons/home-export.svg" style="height: 25px;" />
        </a>
      </li>
    </ul>
    <div class="px-3 pb-4 pt-3 w-100">
      <button class="btn btn-primary-300 rounded-pill w-100 py-3 fs-4 fw-normal" [routerLink]="['acceder']"
        data-bs-toggle="collapse" data-bs-target="#mobileMenu">
        Acceder
      </button>
    </div>
  </div>
  }
  @else if(isAuthPage) {
  <div class="container-fluid align-items-center justify-content-between">

    <span class="text-decoration-none d-flex align-items-center mt-2 text-normal cursor-pointer"
      (click)="handleGoBack()">
      <i class="bi bi-chevron-left"></i>
    </span>

    <a class="navbar-brand d-flex align-items-center" href="#">
      <img src="Logo.svg" alt="Vida Óptima" height="40" class="me-2" />
    </a>

    <a href="#" class="text-decoration-none d-flex align-items-center mt-2 text-normal">
      <i class="bi bi-chat-left-text"></i>
    </a>

  </div>
  }
</nav>